module.exports = __webpack_public_path__ + "img/bg.f548a512.jpg";